import React, { useEffect, useState } from 'react';
import { data as snowData } from './snowData';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

const SnowChart = () => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  );

  const options = {
    plugins: {
      title: {
        display: true,
      },
      legend: {
        align: 'start',
        labels: {
          boxWidth: 15,
          boxHeight: 15,
          useBorderRadius: true,
        },
      },
    },
    layout: {
      padding: {
        bottom: 30,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    /*scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: false,
          },
        },*/
  };
  const optionsMobile = {
    plugins: {
      title: {
        display: true,
      },
      legend: {
        align: 'start',
        labels: {
          boxWidth: 15,
          boxHeight: 15,
          useBorderRadius: true,
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    /*scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: false,
          },
        },*/
  };

  const { t } = useTranslation(['charts']);

  const labels = ['December', 'Januari', 'Februari', 'Mars', 'April'];

  const [variable, setVariable] = useState('avg_snow_depth');
  const [destination, setDestination] = useState(null);
  const [mobileDestination, setMobileDestination] = useState('Bad Gastein');

  const [data, setData] = useState({});
  const [mobileData, setMobileData] = useState({});

  useEffect(() => {
    getData();
    getDataMobile();
  }, [destination, mobileDestination, variable]);

  useEffect(() => {
    getData();
    getDataMobile();
  }, []);

  const allDatasetLabels = [
    ...new Set(snowData.map((item) => item.destination)),
  ];

  const [datasetLabels, setDatasetLabels] = useState(allDatasetLabels);

  const colors = ['#FFFCED', '#FFFADB', '#FFF5B6', '#FFF19E', '#FFEA6E'];

  const getDataMobile = () => {
    let datasets = [];

    labels.forEach((l, i) => {
      const sd = snowData.filter((d) => {
        return d.destination === mobileDestination && d.month === l;
      });

      const data = sd.map((d) => d[variable]);

      const dataset = {
        label: t(l),
        data: data,
        type: 'bar',
        backgroundColor: colors[i],
        borderRadius: 5,
        borderColor: '#CCCCCC',
        borderWidth: 2,
      };
      datasets.push(dataset);
    });

    const data = {
      labels: mobileDestination ? [mobileDestination] : allDatasetLabels,
      datasets: datasets,
    };

    setDatasetLabels(
      mobileDestination ? [mobileDestination] : allDatasetLabels,
    );
    setMobileData(data);
  };

  const getData = () => {
    let datasets = [];

    labels.forEach((l, i) => {
      const sd = snowData.filter((d) => {
        if (destination) {
          return d.destination === destination && d.month === l;
        } else {
          return d.month === l;
        }
      });

      const data = sd.map((d) => d[variable]);

      const dataset = {
        label: t(l),
        data: data,
        type: 'bar',
        backgroundColor: colors[i],
        borderRadius: 5,
        borderColor: '#CCCCCC',
        borderWidth: 2,
      };
      datasets.push(dataset);
    });

    const data = {
      labels: destination ? [destination] : allDatasetLabels,
      datasets: datasets,
    };

    setDatasetLabels(destination ? [destination] : allDatasetLabels);
    setData(data);
  };

  const onOptionChange = (e) => {
    setVariable(e.target.value);
  };

  const destinationlabel = t('destination');
  const variableLabel = t('variable');

  return (
    <div className="col-span-12 mt-12 p-4 rounded-lg max-h-[80vh] md:max-h-[60vh]">
      <div className="flex flex-col md:flex-row">
        <div
          className={`bg-yellow-30 font-crystalCondensed mb-2 lg:mb-0 w-full md:w-1/4 rounded-lg relative mr-1 md:hidden`}
        >
          <label
            className="text-xxs px-3 w-full text-black-50 absolute top-1 "
            htmlFor="destinationMobile"
          >
            {destinationlabel}
          </label>
          <select
            id="destinationMobile"
            className={`bg-transparent w-full form-select border-0 pt-4 pb-1`}
            onChange={(e) => {
              setMobileDestination(e.target.value);
            }}
            value={mobileDestination}
          >
            {allDatasetLabels.map((dest) => (
              <option key={dest} value={dest}>
                {dest}
              </option>
            ))}
          </select>
        </div>
        <div
          className={`bg-yellow-30 font-crystalCondensed mb-2 lg:mb-0 w-full md:w-1/4 rounded-lg relative mr-1 hidden md:block`}
        >
          <label
            className="text-xxs px-3 w-full text-black-50 absolute top-1 "
            htmlFor={destinationlabel}
          >
            {destinationlabel}
          </label>
          <select
            id="destination"
            className={`bg-transparent w-full form-select border-0 pt-4 pb-1`}
            onChange={(e) => {
              setDestination(e.target.value);
            }}
            value={destination}
          >
            <option key="all" value="">
              {t('all')}
            </option>
            {allDatasetLabels.map((dest) => (
              <option key={dest} value={dest}>
                {dest}
              </option>
            ))}
          </select>
        </div>
        <div
          className={`bg-yellow-30 font-crystalCondensed mb-2 lg:mb-0 w-full md:w-1/4 rounded-lg relative `}
        >
          <label
            className="text-xxs px-3 w-full text-black-50 absolute top-1"
            htmlFor={variableLabel}
          >
            {variableLabel}
          </label>
          <select
            id="variable"
            className={`bg-transparent w-full form-select border-0 pt-4 pb-1`}
            onChange={onOptionChange}
            value={variable}
          >
            <option value="avg_snow_depth">{t('avg_snow_depth')} (cm)</option>
            <option value="avg_snowfall">{t('avg_snowfall')} (cm)</option>
            <option value="biggest_snowfall">
              {t('biggest_snowfall')} (cm)
            </option>
            <option value="snowfall_days">{t('snowfall_days')}</option>
          </select>
        </div>
      </div>
      {data.datasets?.length > 0 && (
        <div className=" hidden md:block relative min-h-[60vh]">
          <Bar options={options} data={data} className="aspect-square" />
        </div>
      )}
      {mobileData.datasets?.length > 0 && (
        <div className="block md:hidden min-h-[60vh]">
          <Bar
            options={optionsMobile}
            data={mobileData}
            className="aspect-square relative "
          />
        </div>
      )}
    </div>
  );
};

export default SnowChart;
